import cn from 'clsx'

import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { changeVolume } from '@disco/state-management/actions/MediaActions'
import Button from 'components/ui/button'
import VolumePopup from './volume-popup'
import styles from './index.module.css'

/**
 * Player volume control component with mute/unmute functionality
 * Provides volume slider popup and mute toggle button with state management
 * Remembers volume level before muting for proper restoration
 */
const PlayerVolume = (): React.ReactElement<'div'> => {
  const dispatch = useDispatch()
  const volume: number = useSelector(state => state.media.volume)
  const [volumeBeforeMute, setVolumeBeforeMute] =
    useState<number | null | undefined>()
  const handleChange = useCallback(
    (volume: number) => {
      dispatch(changeVolume(volume))
    },
    [dispatch],
  )

  const toggleMute = () => {
    if (volume === 0) {
      dispatch(changeVolume(volumeBeforeMute || 1))
    } else {
      setVolumeBeforeMute(volume)
      dispatch(changeVolume(0))
    }
  }

  return (
    <div
      className={cn(styles.playerVolume, {
        [styles.playerVolumeDisabled]: volume === 0,
      })}
    >
      <Button appearance="icon" icon="player-volume" onClick={toggleMute} />
      <div className={styles.playerVolumeSlider}>
        <VolumePopup volume={volume} onChange={handleChange} />
      </div>
    </div>
  )
}

export default PlayerVolume
